import {CustomerInput} from "@/endpoints/rutsolve/gql/generated/types"

export class CustomerSelector {
    static readonly customerInput: string = "CUSTOMER_SELECTOR_CUSTOMER_INPUT"
    static readonly selectedCustomerID: string = "CUSTOMER_SELECTOR_SELECTED_CUSTOMER_ID"

    private static defaultCustomerInput: CustomerInput = {
        customerFilter: {
            types: []
        },
        order: "UPDATED_AT_DESCENDING",
        plot: {
            items: 10,
            page: 1
        },
    }

    public static readCustomerInput(): CustomerInput {
        const customerInput = sessionStorage.getItem(this.customerInput)
        if (customerInput) {
            return JSON.parse(customerInput) as CustomerInput
        }
        return this.defaultCustomerInput
    }

    public static readSelectedCustomerID(): string {
        return sessionStorage.getItem(this.selectedCustomerID)
    }

    public static writeCustomerInput(input: CustomerInput) {
        sessionStorage.setItem(this.customerInput, JSON.stringify(input))
    }

    public static writeSelectedCustomerID(input: string) {
        sessionStorage.setItem(this.selectedCustomerID, input)
    }

    public static deleteCustomerInput() {
        sessionStorage.removeItem(this.customerInput)
    }

    public static deleteSelectedCustomerID() {
        sessionStorage.removeItem(this.selectedCustomerID)
    }
}
